export const COL = {
  qty: 70,
  qtyInput: 215,
  textInput: 150,
  select: 210,
  selectWide: 265,
  text: 150,
  dateTime: 150,
  status: 120,
  image: 70,
  product: 280,
};

export const colStyle = (width) => ({ width: width, maxWidth: width });

export const colCellStyle = (width) => ({
  padding: 'var(--p-space-150)',
  width: `${width}px`,
  maxWidth: `${width}px`,
});

export const colFlexStyle = (minWidth) => ({ minWidth: minWidth, width: 'auto' });
